export default __webpack_public_path__ + "static/media/watch-header-gold.9bce4f85.svg";